import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 27 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 23\" id=\"icon-list\"><path d=\"M26.167 2V0H0v2zm0 10.408v-2H0v2zm0 10.409v-2H0v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol